import { IIconProps } from '@app/models';
import * as React from 'react';

const Icon: React.FC<IIconProps> = (props) => {
	const { name, className, titleAccess, fontSize, ...rest } = props;
	return (
		<i
			className={`maersk-icon maersk-icon-font-${fontSize ?? 'medium'} ${className ?? ''}`}
			aria-label={titleAccess}
			{...rest}
		>
			{name}
		</i>
	);
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/shared/icon.component.tsx